import React from 'react';

import Currency from 'components/Currency';
import decodeHtml from 'utilities/decodeHtml';

function PriceChangeNotificationViewTemplate ({ helpers, modelAttributes }) {

	const { PriceChangeNotifications } = modelAttributes;

	return (
		<>
			<div className="headerText">The Following Prices Have Changed</div>
			<div className="productItems">
				{PriceChangeNotifications?.map((item, index) => {

					const {
						ProductImageUrl, ProductName, ShortSku, OldPrice, NewPrice
					} = item;
					const productName = decodeHtml(ProductName);

					return (
						<>
							<div className="productCell" key={`priceChangeNotifications-${index}`}>
								<div className="productImage">
									<img src={ProductImageUrl} alt={productName} height="170" width="170" />
								</div>
								<div className="productNameWrapper">
									<div className="productName">
										{productName}
										{' - Style # '}
										{ShortSku}
									</div>
									<div className="newPriceCell">
										{'Price has increased from '}
										<Currency price={OldPrice} />
										{' to '}
										<Currency price={NewPrice} />
									</div>
								</div>
							</div>
						</>
					);

				})}
			</div>
			<button type="button" className="btnDismiss calloutBtn alt1 fr">
				Ok
			</button>
		</>
	);

}

export default PriceChangeNotificationViewTemplate;
